import RenewDialog from './RenewDialog';
import ConnectedRenewDialog from './ConnectedRenewDialog';

export { RenewDialog };
export default ConnectedRenewDialog;
